export default function capitalizeFirstLetter(val: string): string {
  const lowerCaseVal = String(val).toLowerCase();
  return (
    String(lowerCaseVal).charAt(0).toUpperCase() + String(lowerCaseVal).slice(1)
  );
}
